var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMx = function SvgIconMx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 12a12 12 0 0 0-6.783-10.81V22.81a12 12 0 0 0 6.782-10.81"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6DA544"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12a12 12 0 0 0 6.783 10.809V1.19A12 12 0 0 0 0 12M8.87 12a3.13 3.13 0 0 0 6.261 0v-1.044h-6.26z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M16.173 9.913h-3.13a1.044 1.044 0 0 0-2.087 0h-3.13c0 .577.501 1.044 1.077 1.044H8.87c0 .576.467 1.043 1.043 1.043 0 .577.467 1.044 1.044 1.044h2.087c.576 0 1.043-.467 1.043-1.044.576 0 1.044-.467 1.044-1.043h-.035c.576 0 1.078-.467 1.078-1.044"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconMx;